import { styled, Select } from "@mui/material";

export const StyledSelect: any = styled(Select)`
  &
    .css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.css-jedpe8-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
    cursor: ${({ $readOnly }: any) => ($readOnly ? "not-allowed" : "pointer")};
  }
`;
